import React, { useEffect, useMemo, useState } from 'react'
import { DatePicker, Form, Input, message, Select } from "antd";
import { Button } from "evergreen-ui";
import { getDatabase, ref, update } from "firebase/database";
import Firebase from "../../Firebase/Firebase";
import FireFetch from "../../Firebase/FireFetch";
import { useAuth } from "../../AuthContext/AuthContext";
import { getCallable } from "../../Firebase/functionsClient";

const moment = require("moment");
var db = getDatabase(Firebase);
const EditSurvey = (props) => {
	const { canAccessModule, firebaseUser, loading: authLoading } = useAuth();
	const canUpdateSurvey = canAccessModule("SURVEYS", "update");
	const [users, setUsers] = useState([]);
	const [usersLoading, setUsersLoading] = useState(false);
	const userOptions = useMemo(() => {
		const options = (users || []).map((item) => ({
			label: `${item.firstname || ""} ${item.surname || ""}`.trim() || item.name || item.id,
			value: item.id,
		}));
		const existingIds = new Set(options.map((option) => option.value));
		(props.survey?.assignedUsers || []).forEach((userId) => {
			if (userId && !existingIds.has(userId)) {
				options.push({
					label: userId,
					value: userId,
				});
			}
		});
		return options;
	}, [props.survey?.assignedUsers, users]);

	useEffect(() => {
		let isMounted = true;

		const loadVisibleUsers = async () => {
			if (authLoading) return;
			if (!firebaseUser) {
				setUsers([]);
				return;
			}

			setUsersLoading(true);
			try {
				const res = await getCallable("listUsers")({});
				const visibleUsers = Array.isArray(res?.data?.users) ? res.data.users : [];
				if (isMounted) {
					setUsers(visibleUsers);
				}
			} catch (error) {
				console.error("Unable to load users for survey edit:", error);
				if (isMounted) {
					setUsers([]);
				}
			} finally {
				if (isMounted) {
					setUsersLoading(false);
				}
			}
		};

		loadVisibleUsers();
		return () => {
			isMounted = false;
		};
	}, [authLoading, firebaseUser]);

	const editSurvey = (values) => {
		if (!canUpdateSurvey) {
			message.error("You do not have permission to update surveys.");
			return;
		}

		var surveyObject = values;
		surveyObject.expires = values.expires ? values.expires.format("YYYY-MM-DDTHH:mm") : "";

		var surveyID = props.survey?.surveyID;

		update(ref(db, "talmidsdb/surveys/" + surveyID), surveyObject)
			.then(() => {
				FireFetch.addLog("surveys", surveyID, "Edit");
				message.success('Survey Edited Successfully!');
			})
			.catch((error) => {
				message.error('Unable to edit Survey!');
			})
	}

	return (
		<>
			<Form
				layout="vertical"
				onFinish={editSurvey}
				className="p-3 font-Nunito"
				initialValues={{
					title: props.survey?.title,
					assignedUsers: props.survey?.assignedUsers,
					expires: moment(props.survey?.expires, "YYYY-MM-DDTHH:mm"),
				}}
			>
				<Form.Item label="Survey Title" name="title"
					rules={[{ required: true, message: 'Please input title!' }]}>
					<Input placeholder="enter survey title" id="title" />
				</Form.Item>
				<Form.Item label="Assigned Users" name="assignedUsers"
					rules={[{ required: true, message: 'Please select assigned users!' }]}>
					<Select placeholder="Select assigned users"
						showSearch
						mode="multiple"
						loading={usersLoading}
						options={userOptions}
						optionFilterProp="label"
						filterOption={(input, option) =>
							String(option?.label || "").toLowerCase().indexOf(input.toLowerCase()) >= 0
						}
						filterSort={(optionA, optionB) =>
							String(optionA?.label || "").toLowerCase().localeCompare(String(optionB?.label || "").toLowerCase())
						}
					/>
				</Form.Item>
				<Form.Item
					label="Survey expiry date"
					name="expires"
					rules={[{ required: true, message: 'Please select expiry date!' }]}>
					<DatePicker
						showTime={{ format: 'HH:mm' }}
						format="YYYY-MM-DD HH:mm"
						placeholder="select survey's expiry date"
						picker={"date"}
						className="w-100" />
				</Form.Item>


				<Button id="btnSubmit" appearance="primary" htmlType="submit" disabled={!canUpdateSurvey}>
					Save
				</Button>

			</Form>
		</>
	)
}

export default EditSurvey;
